import { Fragment } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, Dialog, DialogError } from '@pocketlaw/tetris';
export function ErrorDialog(props) {
    const { onClose, onRetry } = props;
    return (<Dialog onClose={onClose}>
      <DialogError title={t({ message: 'Error', comment: 'Filesystem dialog error title' })} description={t({
            message: 'Something went wrong, please try again later.',
            comment: 'Filesystem dialog error message',
        })} actions={<Fragment>
            <Button type="button" appearance="secondary" onClick={onClose}>
              <Trans comment="Filesystem dialog error">Close</Trans>
            </Button>
            {onRetry && (<Button type="button" onClick={onRetry}>
                <Trans comment="Filesystem dialog error">Retry</Trans>
              </Button>)}
          </Fragment>}/>
    </Dialog>);
}
